import { apiInstance } from 'api/utils';

interface ImageType {
  [key: string]: string;
}

export default {
  generatePdf: ({
    portfolio,
    images,
    type,
    upload_to_io,
    portfolioType,
    scatterChartData,
    report_sections,
    existingPerformanceData,
    recommendedPerformanceData
  }: {
    portfolio?: any;
    images: ImageType;
    type: string;
    upload_to_io: boolean;
    portfolioType?: string;
    scatterChartData?: object;
    report_sections?: object;
    existingPerformanceData: object;
    recommendedPerformanceData: object;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/ips/download/`,
      responseType: 'blob',
      data: {
        type,
        upload_to_io,
        ...images,
        portfolioType,
        scatterChartData,
        report_sections,
        existingPerformanceData,
        recommendedPerformanceData
      }
    });
  }
};
